/**
 * Update document title and key SEO/social meta tags for the current route.
 * Use this inside a useEffect at the top of each Page component so search engines
 * and social previews (OG/Twitter) see route-specific content, not the static
 * defaults baked into index.html.
 */
const SITE_URL = "https://emi-harmony.ch";

const setOrCreateMeta = (selector, attrName, attrValue, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setOrCreateLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function setPageMeta({
  title,
  description,
  path = "/",
  image,
  type = "website",
  noindex = false,
}) {
  if (title) {
    document.title = title;
    setOrCreateMeta('meta[name="title"]', "name", "title", title);
    setOrCreateMeta('meta[property="og:title"]', "property", "og:title", title);
    setOrCreateMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
  }
  if (description) {
    setOrCreateMeta('meta[name="description"]', "name", "description", description);
    setOrCreateMeta('meta[property="og:description"]', "property", "og:description", description);
    setOrCreateMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
  }
  const url = `${SITE_URL}${path}`;
  setOrCreateLink("canonical", url);
  setOrCreateMeta('meta[property="og:url"]', "property", "og:url", url);
  setOrCreateMeta('meta[property="og:type"]', "property", "og:type", type);
  if (image) {
    setOrCreateMeta('meta[property="og:image"]', "property", "og:image", image);
    setOrCreateMeta('meta[name="twitter:image"]', "name", "twitter:image", image);
  }
  setOrCreateMeta(
    'meta[name="robots"]',
    "name",
    "robots",
    noindex
      ? "noindex, nofollow"
      : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  );
}

export const DEFAULT_META = {
  title: "EMI Harmony | Massaggio Medicale Locarno-Riazzino - Massaggiatrice CRS",
  description:
    "Massaggi medicali riconosciuti da oltre 30 casse malati (LCA) a Riazzino-Locarno. Massaggiatrice CRS. Riflessologia, Hot Stones, Lomi Lomi.",
  path: "/",
  image:
    "https://res.cloudinary.com/dbbtcjtb5/image/upload/v1774529542/emi-harmony/hero_medical.jpg",
};

export const DEFAULT_META_DE = {
  ...DEFAULT_META,
  title: "EMI Harmony | Medizinische Massage Locarno-Riazzino – Masseurin SRK",
  description:
    "Medizinische Massage in Riazzino bei Locarno, von über 30 Zusatzversicherungen (VVG) anerkannt. Reflexzonenmassage, Hot Stones, Lomi Lomi.",
  path: "/de",
};

export function resetPageMeta() {
  setPageMeta(DEFAULT_META);
}
